<template>
  <div>
    <CollectionView :endpoint="utilities.path('players/@/related-players', playerId)" searchable v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("related_players") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">{{ translate("identifier") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView :player="item"/>
                  </div>
                  <div class="table-column">
                    {{ item.identifier.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {CollectionView, utilities} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import {ref, watch} from "vue";

const props = defineProps({
  playerId: String
});

const reload = ref(false);

watch(() => props.playerId, () => {
  reload.value = true;
});
</script>

<style scoped>

</style>
